<template>
    <div>
        <kgr-loading v-if="loading" />
        <kgr-form-scaffold
            v-else
            :with-delete-button="false"
            :with-back-button="false"
            :pending="pending"
            @primaryBtnClicked="save"
        >
            <div class="kgr-grid kgr-grid--columnGutters">
                <fieldset class="kr-grid_cell kgr-grid__cell--5of12">
                    <legend
                        v-t="'Benachrichtigungen'"
                        class="kgr-headline kgr-headline--h3 kgr-headline--text kgr-headline--firstInText"
                    ></legend>
                    <kgr-club-employee-notifications-form
                        v-if="clubEmployeeAccountSettings"
                        :club-employee="clubEmployeeAccountSettings"
                        :offering-module-enabled="offeringModuleEnabled"
                        @change="updateAccountSetting($event)"
                    />
                </fieldset>
                <div class="kr-grid_cell kgr-grid__cell--1of12"></div>

                <fieldset class="kr-grid_cell kgr-grid__cell--5of12">
                    <legend
                        v-t="'Profilfoto'"
                        class="kgr-headline kgr-headline--h3 kgr-headline--text kgr-headline--firstInText"
                    ></legend>
                    <kgr-club-employee-avatar-form
                        v-if="clubEmployeeAccountSettings"
                        :club-employee-account-settings="clubEmployeeAccountSettings"
                    />
                </fieldset>
            </div>
            <div style="height:30px"></div>

            <div class="kgr-row">
                <fieldset class="kr-grid_cell kgr-grid__cell--5of12">
                    <legend
                        v-t="'Digitale Unterschrift'"
                        class="kgr-headline kgr-headline--h3 kgr-headline--text kgr-headline--firstInText"
                    ></legend>
                    <kgr-signature-pad
                        v-if="clubEmployeeAccountSettings"
                        :on-finished="onSignatureFinished"
                        :data="clubEmployeeAccountSettings.signature"
                        styleguide-included
                        @cleared="clubEmployeeAccountSettings.signature = null"
                    />
                </fieldset>
            </div>
        </kgr-form-scaffold>
    </div>
</template>

<script>
import ClubEmployeeAccountSettingsRepository from '../../js/repository/ClubEmployeeAccountSettingsRepository.js';
import ClubEmployeeAvatarForm from '../../components/employees/ClubEmployeeAvatarForm.vue';
import ClubEmployeeNotificationsForm from '../../components/employees/ClubEmployeeNotificationsForm.vue';
import FormScaffold from '../../components/common/form/FormScaffold.vue';
import Loading from '../../components/common/Loading.vue';
import SignaturePad from '../../components/service/SignaturePad.vue';

export default {
    components: {
        'kgr-form-scaffold': FormScaffold,
        'kgr-loading': Loading,
        'kgr-club-employee-notifications-form': ClubEmployeeNotificationsForm,
        'kgr-club-employee-avatar-form': ClubEmployeeAvatarForm,
        'kgr-signature-pad': SignaturePad,
    },
    props: {
        clubId: {
            type: Number,
            required: true,
        },
        employeeId: {
            type: Number,
            required: true,
        },
        message: {
            type: String,
            required: false,
            default: null,
        },
        offeringModuleEnabled: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            loading: false,
            pending: false,
            clubEmployeeAccountSettings: null,
        };
    },
    mounted() {
        this.loadClubEmployee();
        if (this.message) {
            this.$notify.success(this.message);
        }
    },
    methods: {
        loadClubEmployee() {
            this.loading = true;
            ClubEmployeeAccountSettingsRepository.getData(this.employeeId)
                .then((clubEmployee) => {
                    this.clubEmployeeAccountSettings = clubEmployee;
                    this.loading = false;
                });
        },
        save() {
            this.pending = true;
            ClubEmployeeAccountSettingsRepository.updateData(this.clubEmployeeAccountSettings)
                .then(() => this.$notify.success('saveChanges.success'))
                .catch(() => this.$notify.error('saveChanges.error'))
                .finally(() => this.pending = false);
        },
        onSignatureFinished(imageData) {
            if (this.clubEmployeeAccountSettings) {
                this.clubEmployeeAccountSettings.signature = imageData;
            }
        },
        updateAccountSetting(accountSettings) {
            this.clubEmployeeAccountSettings = accountSettings;
        },
    },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss"></style>
